import { props } from './syllabus-block-utils';
import Block from './block';

export default {
  template: '#spacer-block-template',
  props,
  data() {
    return Object.assign({
      title: '',
      content: '',
      lines: 1,
      showOnPublicSyllabus: true,
    }, this.rootData);
  },
  components: {
    Block
  },
  watch: {
    dataForSave() {
      this.$emit('block-update', this.dataForSave);
    },
  },
  computed: {
    lineText() {
      if ( this.lines > 1 ) {
        return `${this.lines} lines`;
      }
      return '1 line';
    },
    dataForSave() {
      return {
        uuid: this.uuid,
        data: {
          title: this.title,
          lines: this.lines,
          content: this.content,
          showOnPublicSyllabus: this.showOnPublicSyllabus
        }
      };
    },
    // needed for block interface
    isEmpty() {
      return false;
    }
  },
};
